import { PageComponentTagId } from '../../../models';
import { OVERVIEW_TAB_WIDGET_ID } from '../Company.constants';

export const DYNAMIC_PRINTABLE_SECTIONS: string[] = [
  PageComponentTagId.RISKS_CATALYSTS,
  PageComponentTagId.CREDIT_VIEW,
  PageComponentTagId.KEY_METRICS,
  PageComponentTagId.RELATIVE_VALUE,
  PageComponentTagId.ESG,
  PageComponentTagId.FLEX1,
  PageComponentTagId.CAPITAL_STRUCTURE,
  PageComponentTagId.MNA,
  PageComponentTagId.LITIGATION,
  PageComponentTagId.MANAGEMENT_COMMENTARY,
  PageComponentTagId.FLEX2,
  PageComponentTagId.OPERATING_CONDITION,
  PageComponentTagId.FINANCIAL_CONDITION,
  PageComponentTagId.FLEX3,
  PageComponentTagId.LEASE_ADJUSTMENTS,
  PageComponentTagId.CORPORATE_STRUCTURE,
  PageComponentTagId.COVENANTS,
  PageComponentTagId.FLEX4,
  PageComponentTagId.SIZE_GEOGRAPHY,
  PageComponentTagId.FLEX5,
];

export const STATIC_PRINTABLE_SECTIONS = {
  COMPANY_OVERVIEW: {
    id: OVERVIEW_TAB_WIDGET_ID.COMPANY_OVERVIEW,
    label: 'Company Overview',
  },
  CS_VIEW: {
    id: OVERVIEW_TAB_WIDGET_ID.CS_VIEW,
    label: 'CS View',
  },
  RISK_PRODUCTS: {
    id: OVERVIEW_TAB_WIDGET_ID.RISK_PRODUCT,
    label: 'Risk Products',
  },
  RECENTLY_PUBLISHED: {
    id: OVERVIEW_TAB_WIDGET_ID.RECENTLY_PUBLISHED,
    label: 'Recently Published',
  },
  DEALS: {
    id: OVERVIEW_TAB_WIDGET_ID.DEALS,
    label: 'Deals',
  },
};

export const ORDERED_PRINTABLE_SECTIONS = [
  STATIC_PRINTABLE_SECTIONS.COMPANY_OVERVIEW.id,
  STATIC_PRINTABLE_SECTIONS.CS_VIEW.id,
  ...DYNAMIC_PRINTABLE_SECTIONS,
  STATIC_PRINTABLE_SECTIONS.RISK_PRODUCTS.id,
  STATIC_PRINTABLE_SECTIONS.RECENTLY_PUBLISHED.id,
  STATIC_PRINTABLE_SECTIONS.DEALS.id,
];

export const PRINTABLE_SECTIONS_WITHOUT_CS_COVERAGE = [
  STATIC_PRINTABLE_SECTIONS.COMPANY_OVERVIEW,
  STATIC_PRINTABLE_SECTIONS.RISK_PRODUCTS,
  STATIC_PRINTABLE_SECTIONS.RECENTLY_PUBLISHED,
  STATIC_PRINTABLE_SECTIONS.DEALS,
];
